<script lang="ts" module>
  import { Portal } from "#lib/internal/components"
</script>

<script lang="ts">
  import type { Snippet } from "svelte"
  import { getDialogRootContext } from "./DialogRoot.svelte"

  type Props = {
    container?: string | HTMLElement
    children?: Snippet
    [key: string]: unknown
  }

  let { container = "body", children, ...restProps }: Props = $props()

  const rootCtx = getDialogRootContext()
</script>

{#if $rootCtx.open}
  <Portal target={container} {...restProps}>
    {@render children?.()}
  </Portal>
{/if}
